import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth';
import { TabsPage } from './tabs/tabs.page';
import { BlankPage } from './blank/blank.page';

export const routes: Routes = [
    {
        path: '',
        //loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
        //canActivate: [AuthGuard]
        redirectTo: "tabs",
        pathMatch: "full"
        //loadComponent: () => import('./app.loading').then(c => c.LoadingPage)
    },
    {
        path: "auth",
        loadComponent: () => import("./components/auth/auth.component").then(c => c.AuthComponent)
    },
    {
        path: 'home/:uid',
        pathMatch: "full",
        loadComponent: () => import('./home/home.page').then(m => m.HomePage),
    },
    {
        path: 'tabs',
        component: TabsPage,
        canActivate: [AuthGuard],
        children: [
            {
                path: "",
                redirectTo: "home",
                pathMatch: "prefix"
            },
            {
                path: 'home',
                loadComponent: () => import('./home/home.page').then(m => m.HomePage),
            },
            {
                path: 'prizes',
                loadComponent: () => import('./prizes/prizes.page').then(m => m.PrizesPage),
            },
            {
                path: 'places',
                loadComponent: () => import('./places/places.page').then(m => m.PlacesPage),
                children: [
                    {
                        path: 'activities',
                        loadComponent: () => import('./places/activities/activities.page').then(m => m.ActivitiesPage)
                    }
                ]
            },
            {
                path: 'booking',
                loadComponent: () => import('./booking/booking.page').then(m => m.BookingPage)
            },
            {
                path: 'notifications',
                loadComponent: () => import('./notifications/notifications.page').then(m => m.NotificationsPage)
            }
        ],
    },
    {
        path: "confetti/:tid",
        loadComponent: () => import("./confetti/confetti.component").then(c => c.ConfettiComponent)
    },
    {
        path: 'loading',
        loadComponent: () => import('./app.loading').then(c => c.LoadingPage),
    },
    {
        path: 'terms',
        loadComponent: () => import('./terms/terms.page').then(m => m.TermsPage)
    },
    {
        path: 'landing',
        loadComponent: () => import('./app.landing').then(c => c.LandingPage)
    },

    {
        path: 'service',
        loadComponent: () => import('./service/service.page').then(m => m.ServicePage)
    },
    {
        path: 'notification/service/:sid',
        loadComponent: () => import('./service/service.page').then(m => m.ServicePage)
    },
    {
        path: 'notification/training/:tid',
        loadComponent: () => import('./training/training.page').then(m => m.TrainingPage)
    },
    {
        path: "qr-code",
        loadComponent: () => import('./qr-code/qr-code.page').then(m => m.QrCodePage)
    },
    {
        path: "qr-scanner",
        loadComponent: () => import('./qr-scanner/qr-scanner.page').then(m => m.QrScannerPage)
    },
    {
        path: 'service/:uid/:stype/:sid',
        loadComponent: () => import('./qr-code-verify/qr-code-verify.page').then(m => m.QrCodeVerifyPage)
    },

    {
        path: 'shipping-data',
        loadComponent: () => import('./shipping-data/shipping-data.page').then(m => m.ShippingDataPage)
    },
    {
        path: 'booking-detail',
        loadComponent: () => import('./booking-detail/booking-detail.page').then(m => m.BookingDetailPage)
    },
    {
        path: 'tutorial',
        loadComponent: () => import('./tutorial/tutorial.page').then(m => m.TutorialPage)
    },
    {
        path: 'alltraining',
        loadComponent: () => import('./alltraining/alltraining.page').then(m => m.AlltrainingPage)
    },
    {
        path: 'alltraining/:type',
        loadComponent: () => import('./alltraining/alltraining.page').then(m => m.AlltrainingPage)
    },
    {
        path: 'embed/:tid',
        loadComponent: () => import('./blank/blank.page').then(m => m.BlankPage)
        //component: BlankPage
    },
    {
        path: 'brands',
        loadComponent: () => import('./brands/brands.page').then(m => m.BrandsPage)
    },
    {
        path: 'services/:type',
        loadComponent: () => import('./services/services.page').then(m => m.ServicesPage)
    },
    {
        path: 'brand/:br_id',
        loadComponent: () => import('./brand/brand.page').then(m => m.BrandPage)
    },
    // {
    //     path: 'trainings',
    //     loadComponent: () => import('./trainings/trainings.page').then(m => m.TrainingsPage)
    // },
    {
        path: 'trainings/:type',
        loadComponent: () => import('./trainings/trainings.page').then(m => m.TrainingsPage)
    },
    {
        path: 'invite',
        loadComponent: () => import('./invite/invite.page').then(m => m.InvitePage)
    },
    // {
    //     path: 'embedded/:contentid',
    //     loadChildren: () => import('./embedded/embedded.module').then(m => m.EmbeddedPageModule)
    // },
    {
        path: 'privacy',
        loadComponent: () => import('./privacy/privacy.page').then(m => m.PrivacyPage)
    },

    // {
    //     path: 'redeem',
    //     loadChildren: () => import('./redeem/redeem.module').then(m => m.RedeemPageModule)
    // },
    {
        path: 'app-update',
        loadComponent: () => import('./app-update/app-update.page').then(m => m.AppUpdatePage)
    },
    {
        path: 'email-verification',
        loadComponent: () => import('./email-verification/email-verification.page').then(m => m.EmailVerificationPage)
    },
    {
        path: 'password-reset',
        loadComponent: () => import('./password-reset/password-reset.page').then(m => m.PasswordResetPage)
    },
    {
        path: 'group-privacy',
        loadComponent: () => import('./group-privacy/group-privacy.page').then(m => m.GroupPrivacyPage)
    },
    {
        path: 'not-available',
        loadComponent: () => import('./not-available/not-available.page').then(m => m.NotAvailablePage)
    },
    {
        path: 'verify-success',
        loadComponent: () => import('./verify-success/verify-success.page').then(m => m.VerifySuccessPage)
    },
    {
        path: 'training-video',
        loadComponent: () => import('./training-video/training-video.page').then(m => m.TrainingVideoPage)
    },
    {
        path: 'quiz',
        loadComponent: () => import('./training-video/quiz/quiz.page').then(m => m.QuizPage)
    },
    {
        path: 'prize-detail/:sid',
        loadComponent: () => import('./prizes/prize-detail/prize-detail.page').then(m => m.PrizeDetailPage)
    },
    {
        path: 'auth-nav',
        loadComponent: () => import('./auth-nav/auth-nav.page').then(m => m.AuthNavPage)
    },
    {
        path: 'auth-fields',
        loadComponent: () => import('./auth-nav/auth-fields/auth-fields.page').then(m => m.AuthFieldsPage)
    },
    {
        path: 'auth-form',
        loadComponent: () => import('./auth-form/auth-form.page').then(m => m.AuthFormPage)
    },
    {
        path: 'appstore',
        loadComponent: () => import('./appstore/appstore.page').then(m => m.AppstorePage)
    },
    {
        path: 'extrapt',
        loadComponent: () => import('./extrapt/extrapt.page').then(m => m.ExtraptPage)
    },
    {
        path: 'activities',
        loadComponent: () => import('./places/activities/activities.page').then(m => m.ActivitiesPage)
    },
    {
        path: 'activity-detail',
        loadComponent: () => import('./places/activities/activity-detail/activity-detail.page').then(m => m.ActivityDetailPage)
    },
    {
        path: 'places',
        loadComponent: () => import('./places/places.page').then(m => m.PlacesPage)
    },
  {
    path: 'ranking',
    loadComponent: () => import('./ranking/ranking.page').then( m => m.RankingPage)
  },
  {
    path: 'ranking-rules',
    loadComponent: () => import('./ranking/ranking-rules/ranking-rules.page').then( m => m.RankingRulesPage)
  },
  {
    path: 'blank',
    loadComponent: () => import('./blank/blank.page').then( m => m.BlankPage)
  },
  {
    path: 'invite/:gid',
    loadComponent: () => import('./invite-group/invite-group.page').then( m => m.InviteGroupPage)
  },
  {
    path: 'invite/:gid/:uid',
    loadComponent: () => import('./invite-group/invite-group.page').then( m => m.InviteGroupPage)
  },
  {
    path: 'welcome',
    loadComponent: () => import('./welcome/welcome.page').then( m => m.WelcomePage)
  },
  {
    path: 'profile',
    loadComponent: () => import('./profile/profile.page').then( m => m.ProfilePage)
  },
  {
    path: 'friend-invite-confirm',
    loadComponent: () => import('./friend-invite-confirm/friend-invite-confirm.page').then( m => m.FriendInviteConfirmPage)
  }
];